import React from "react";
import Table from "./Table";

export default function PreviewData() {
  return (
    <>
      <Table />
    </>
  );
}
